import Hyperspeed from "../components/Hyperspeed";
import { hyperspeedPresets } from "../presets/hyperspeedPresets";

export default function Background() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none", // 🔥 VERY IMPORTANT
      }}
    >
      <Hyperspeed effectOptions={hyperspeedPresets.one} />
    </div>
  );
}
